import React from 'react';
import { ResumeSection } from './ResumeSection';

interface Props {
  expertise: Record<string, string[]>;
}

export function TechnicalExpertise({ expertise }: Props) {
  const entries = Object.entries(expertise);
  if (!entries.length) return null;

  return (
    <ResumeSection title="Technical Expertise">
      <div className="resume-expertise-grid">
        {entries.map(([category, items]) => (
          <div key={category} className="resume-expertise-group">
            <h3 className="resume-expertise-label">{category}</h3>
            <p className="resume-expertise-items">{items.join(' · ')}</p>
          </div>
        ))}
      </div>
    </ResumeSection>
  );
}
